import { env } from '../envVariables.js.erb';

export const reCAPTCHA = () => {
  $('.js-recaptcha').val(env.RECAPTCHA_SITE_KEY).trigger('captcha-change')
};
